import { useCallback, useMemo } from "react";
import { FILE_BASE_URL } from "../../config";
import Video from "../../components/shared/Video";
import { useDispatch } from "react-redux";
import { updatePosterKey } from "../../store/poster/thunks";
import PrintableImage from "../../components/shared/PrintableImage";

const PosterContent = ({ poster }) => {
  const dispatch = useDispatch();
  const { type, content, fileUrl, domain } = useMemo(() => {
    const { type, content } = poster;

    let domain = "Link";

    if (type === "link") {
      try {
        domain = new URL(content).hostname.replace("www.", "");
      } catch {
        domain = "Link";
      }
    }

    return {
      type,
      content,
      fileUrl: `${FILE_BASE_URL}${content}`,
      domain,
    };
  }, [poster]);

  const onError = useCallback(async () => {
    return await dispatch(
      updatePosterKey({
        poster_id: poster?.id,
      }),
    );
  }, [poster]);

  const contentMap = {
    photo: (
      <>
        <div
          className="blur-bg"
          style={{
            backgroundImage: `url(${fileUrl})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />

        <PrintableImage
          onError={onError}
          className="media-fill"
          src={fileUrl}
          alt="poster"
          style={{
            objectFit: "contain",
            zIndex: 1,
          }}
        />
      </>
    ),
    video: (
      <Video
        onError={onError}
        className="media-fill"
        fileUrl={fileUrl}
        autoPlay
        muted
        loop
        playsInline
      />
    ),

    link: (
      <div className="link-card">
        <div className="link-icon">🔗</div>
        <div className="link-domain">{domain}</div>
        <div className="link-url">{content}</div>
        <a href={content} target="_blank" rel="noopener noreferrer">
          Open link ↗
        </a>
      </div>
    ),
    text: (
      <div className="text-card">
        <div className="quote-mark">"</div>
        <p>{content}</p>
      </div>
    ),
  };

  return <div className="poster-content">{contentMap[type] || null}</div>;
};

export default PosterContent;
